// After Sales Turbolinks Fixer
// This file ensures all inline scripts using DOMContentLoaded will also work with Turbolinks

// Store all DOMContentLoaded handlers
const domContentLoadedHandlers = [];

// Override the native addEventListener to capture DOMContentLoaded handlers
const originalAddEventListener = document.addEventListener;
document.addEventListener = function(type, listener, options) {
  if (type === 'DOMContentLoaded') {
    // Store the handler for later execution on turbolinks:load
    domContentLoadedHandlers.push(listener);
  }
  
  // Still call the original method
  return originalAddEventListener.call(this, type, listener, options);
};

// Execute all the DOMContentLoaded handlers when turbolinks:load fires
document.addEventListener('turbolinks:load', function() {
  console.log(`[Turbolinks Fixer] Re-running ${domContentLoadedHandlers.length} DOMContentLoaded handlers`);
  
  // First, ensure all Chart instances are destroyed
  destroyChartInstances();
  
  // Execute all stored handlers
  domContentLoadedHandlers.forEach(handler => {
    try {
      handler();
    } catch (e) {
      console.error('[Turbolinks Fixer] Error executing handler:', e);
    }
  });
});

// Function to destroy all Chart instances
function destroyChartInstances() {
  if (typeof Chart !== 'undefined') {
    console.log('[Turbolinks Fixer] Destroying Chart instances');
    
    // Destroy Chart instances through ChartInitializer if available
    if (window.ChartInitializer) {
      window.ChartInitializer.destroyAll();
      return;
    }
    
    // Fallback: destroy Chart instances directly
    if (Chart.instances) {
      Object.keys(Chart.instances).forEach(function(key) {
        try {
          Chart.instances[key].destroy();
        } catch (e) {
          console.error('[Turbolinks Fixer] Error destroying Chart instance:', e);
        }
      });
    }
  }
}

// Function to re-initialize any inline scripts
function initializeInlineScripts() {
  console.log('[Turbolinks Fixer] Initializing page-specific handlers');
  
  // Re-initialize datatables
  if (typeof $.fn.DataTable !== 'undefined') {
    $('.datatable:not(.dataTable)').each(function() {
      try {
        $(this).DataTable({
          responsive: true,
          pageLength: 10,
          lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]]
        });
      } catch (e) {
        console.warn('[Turbolinks Fixer] Error initializing datatable:', e);
      }
    });
  }
  
  // Re-initialize select2 elements
  if (typeof $.fn.select2 !== 'undefined') {
    $('select.select2:not(.select2-hidden-accessible)').each(function() {
      try {
        $(this).select2({
          width: '100%',
          placeholder: $(this).data('placeholder') || 'Select an option'
        });
      } catch (e) {
        console.warn('[Turbolinks Fixer] Error initializing select2:', e);
      }
    });
  }
  
  // Handle flash messages
  const flashMessages = document.querySelectorAll('.flash-message .dismiss-flash');
  flashMessages.forEach(button => {
    if (!button.hasAttribute('data-initialized')) {
      button.setAttribute('data-initialized', true);
      button.addEventListener('click', function() {
        const flashElement = this.closest('.flash-message');
        if (flashElement) {
          flashElement.classList.add('opacity-0');
          setTimeout(() => {
            flashElement.remove();
          }, 300);
        }
      });
    }
  });
  
  // Re-initialize barcode scanner if present
  if (typeof window.initBarcodeScanner === 'function' && 
      document.getElementById('scanner-container')) {
    window.initBarcodeScanner();
  }
  
  // Re-initialize form-specific handlers
  if (document.querySelector('form')) {
    initializeFormHandlers();
  }
  
  // Initialize charts if pageSpecificChartInit is defined
  if (typeof window.pageSpecificChartInit === 'function') {
    try {
      // First ensure all Chart instances are destroyed
      destroyChartInstances();
      
      // Then initialize charts
      window.pageSpecificChartInit();
    } catch (e) {
      console.error('[Turbolinks Fixer] Error initializing charts:', e);
    }
  }
}

// Form-specific handlers
function initializeFormHandlers() {
  // Handle nested form fields (Cocoon)
  $(document).off('cocoon:after-insert').on('cocoon:after-insert', function(e, insertedItem) {
    // Re-initialize select2 on newly added nested form elements
    $(insertedItem).find('select.select2').select2({
      width: '100%',
      placeholder: $(this).data('placeholder') || 'Select an option'
    });
  });
  
  // Handle dynamic part additions in service jobs
  const addPartButton = document.getElementById('add-part-button');
  if (addPartButton && !addPartButton.hasAttribute('data-initialized')) {
    addPartButton.setAttribute('data-initialized', true);
    addPartButton.addEventListener('click', function(e) {
      e.preventDefault();
      // Call the handler function if it exists
      if (typeof window.addServicePart === 'function') {
        window.addServicePart();
      }
    });
  }
  
  // Handle date pickers if present
  const datePickers = document.querySelectorAll('input[type="date"]');
  datePickers.forEach(picker => {
    if (!picker.hasAttribute('data-initialized') && typeof $.fn.datepicker !== 'undefined') {
      picker.setAttribute('data-initialized', true);
      $(picker).datepicker({
        format: 'yyyy-mm-dd',
        autoclose: true
      });
    }
  });
}

// Clean up before caching the page
document.addEventListener('turbolinks:before-cache', function() {
  // Destroy Chart instances
  destroyChartInstances();
  
  // Clean up datatables
  if (typeof $.fn.DataTable !== 'undefined') {
    $('.dataTable').DataTable().destroy();
  }
  
  // Clean up select2
  if (typeof $.fn.select2 !== 'undefined') {
    $('.select2-hidden-accessible').select2('destroy');
  }
  
  // Clean up any scanner instances
  if (window.scannerActive) {
    if (window.scannerType === 'quagga' && window.Quagga) {
      window.Quagga.stop();
    } else if (window.scannerType === 'jsqr' && window.videoElement && window.videoElement.srcObject) {
      window.videoElement.srcObject.getTracks().forEach(track => track.stop());
    }
    window.scannerActive = false;
  }
  
  // Reset sidebar on mobile only
  const sidebar = document.querySelector('.sidebar-container');
  if (sidebar && window.innerWidth < 768) {
    sidebar.classList.add('hidden');
    sidebar.style.display = 'none';
  }
  
  // Close any open dropdowns before caching the page
  const openDropdowns = document.querySelectorAll('.dropdown-menu:not(.hidden)');
  openDropdowns.forEach(dropdown => {
    dropdown.classList.add('hidden');
  });
  
  // Be more selective about which Select2 instances to destroy
  // Only destroy the ones we'll explicitly re-initialize
  if (typeof $ !== 'undefined' && typeof $.fn.select2 !== 'undefined') {
    try {
      // Don't destroy all Select2 instances, just reinitialize them properly
      // This prevents issues with the existing Select2 initialization
      console.log('Preserving Select2 instances for proper re-initialization');
    } catch (e) {
      console.error('Error handling Select2 before cache:', e);
    }
  }
});

// Run initializers on both page load and Turbolinks navigation
document.addEventListener('DOMContentLoaded', initializeInlineScripts);
document.addEventListener('turbolinks:load', initializeInlineScripts);

// Export for use in other files
export { initializeInlineScripts };

// Ensure dropdowns are properly initialized after each page load
document.addEventListener('turbolinks:load', function() {
  console.log('Turbolinks load - initializing dropdowns');
  
  // Initialize status dropdown
  const initializeDropdowns = function() {
    const dropdownToggles = document.querySelectorAll('[id^="dropdownMenuButton"]');
    
    dropdownToggles.forEach(function(toggle) {
      // Find the associated dropdown menu
      const toggleId = toggle.id;
      const menuId = toggleId.replace('Button', '');
      const menu = document.getElementById(menuId);
      
      if (toggle && menu) {
        // Remove existing event listeners by cloning
        const newToggle = toggle.cloneNode(true);
        if (toggle.parentNode) {
          toggle.parentNode.replaceChild(newToggle, toggle);
        }
        
        // Add event listener to the new toggle
        newToggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          menu.classList.toggle('hidden');
        });
      }
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(event) {
      const dropdowns = document.querySelectorAll('.dropdown-menu:not(.hidden)');
      dropdowns.forEach(function(dropdown) {
        // Find the associated toggle button
        const toggleId = dropdown.id.replace('dropdown', 'dropdownMenuButton');
        const toggle = document.getElementById(toggleId);
        
        if (toggle && !toggle.contains(event.target) && !dropdown.contains(event.target)) {
          dropdown.classList.add('hidden');
        }
      });
    });
  };
  
  // Initialize dropdowns
  initializeDropdowns();
}); 